const PLATFORM_INFO = {
  android: { name: 'android', defaultStore: 'https://play.google.com/' },
  ios: { name: 'ios', defaultStore: 'https://apps.apple.com/' },
};

export default PLATFORM_INFO;
